import React from 'react';
import styled from 'styled-components';
import { Link, useHistory } from 'react-router-dom';
import { Money } from 'shared/build/Money';
import { convertImageIdToSrcSet } from '../util/functions';
import toys from '../assets/toys.png';
import { NamedColorsHEX, ScreenSizesPx } from '../util/styles';
import { Button, ButtonColorSchema } from 'ui-components/build';
import { HistoryState } from '../util/types';

export type ProductCardProps = {
  imageId?: string;
  description: string;
  price: Money;
  productId: string;
  origin?: string;
};

const ScProduct = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 250px;
  margin: 20px 20px 25px 20px;
  width: 155px;

  @media screen and (min-width: ${ScreenSizesPx.medium}px) {
    width: 205px;
    height: 340px;
  }

  .desc-and-price {
    margin: 7px 0;
    width: 100%;
  }

  p > a {
    color: ${NamedColorsHEX.KahPurple};
  }

  h6 > a {
    color: ${NamedColorsHEX.LightSeaGreen};
  }

  p,
  h6 {
    margin: 0;
    @media screen and (min-width: ${ScreenSizesPx.medium}px) {
      font-size: 1.2em;
    }
  }

  .image {
    border-radius: 4px;
    border: 2px solid ${NamedColorsHEX.LightSlateGray};
    height: 150px;
    width: 150px;
    text-align: center;
    @media screen and (min-width: ${ScreenSizesPx.medium}px) {
      width: 180px;
      height: 180px;
    }

    img {
      max-height: 150px;
      max-width: 150px;

      @media screen and (min-width: ${ScreenSizesPx.medium}px) {
        max-height: 180px;
        max-width: 180px;
      }
    }
  }
`;

const ScButton = styled(Button)`
  height: 30px;
  margin: 0;
  align-self: stretch;
  font-size: 90%;
`;

export const ProductCard = ({
  imageId,
  productId,
  description,
  price,
  origin,
}: ProductCardProps) => {
  const productUrl: string = `/presentes/${productId}`;
  const history = useHistory<HistoryState>();

  return (
    <ScProduct>
      <div className="image">
        <Link
          to={{
            pathname: productUrl,
            state: {
              origin,
            },
          }}
        >
          <img
            alt={description}
            loading="lazy"
            src={toys}
            srcSet={imageId ? convertImageIdToSrcSet(imageId) : ''}
            sizes="200px"
          />
        </Link>
      </div>
      <div className="desc-and-price">
        <p className="babys-cursive">
          <Link
            to={{
              pathname: productUrl,
              state: {
                origin,
              },
            }}
          >
            {description}
          </Link>
        </p>
        <h6 className="babys-cursive">
          <Link
            to={{
              pathname: productUrl,
              state: {
                origin,
              },
            }}
          >
            {price.toString()}
          </Link>
        </h6>
      </div>
      <ScButton
        colorSchema={ButtonColorSchema.primary}
        pointerCursor={true}
        onClick={() =>
          history.push(productUrl, {
            origin,
          })
        }
      >
        Dar esse presente
      </ScButton>
    </ScProduct>
  );
};
